import { useMemo } from 'react';

import type { AccessInput, AccessRules } from '../access/accessAdapter';
import { buildAccessRules } from '../access/accessAdapter';

export const useAccessRules = ({ adminRole, organizerProfile }: AccessInput): AccessRules => {
    return useMemo(
        () => buildAccessRules({ adminRole, organizerProfile }),
        [adminRole, organizerProfile]
    );
};
